<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0

@component
Renders the live (real-time) transcription tab content.
Connects VoiceTextArea to the transcription-realtime WebSocket service
and shows connection errors to users.
-->
<script>
import VoiceTextArea from '../../components/VoiceTextArea.svelte';
import { getRealtimeTranscriptionWsUrl } from '../../config.js';
import { token as keycloakToken } from '../../utils/KeycloakService.js';
import { snackbarStore } from '../../utils/SnackbarStore';
import uiStore from '../../utils/UIStore';

// Reactive i18n text bundle for the live transcription view.
let uiTexts;
uiStore.textStore.subscribe((store) => {
  uiTexts = store.texts;
});

// WebSocket URL for the real-time transcription endpoint.
const wsUrl = getRealtimeTranscriptionWsUrl();
$: wsProtocols = $keycloakToken ? [$keycloakToken] : [];

/**
 * Handle errors emitted by VoiceTextArea (connection failures, WS errors).
 * @param {CustomEvent<Error>} e
 */
function onError(e) {
  console.error('[LiveTranscription] connection error', e.detail);
  snackbarStore.update((current) => ({
    ...current,
    snackbarOpen: true,
    snackbarSeverity: 'error',
    snackbarMessage:
      uiTexts?.transcription?.realtimeTranscription?.connectionError ||
      'Die Echtzeit-Transkription konnte nicht gestartet oder fortgesetzt werden.',
  }));
}
</script>

<VoiceTextArea
  placeholder={uiTexts.transcription.realtimeTranscription.liveHint}
  clearLabel={uiTexts.transcription.realtimeTranscription.liveClear}
  startLabel={uiTexts.transcription.realtimeTranscription.liveStart}
  stopLabel={uiTexts.transcription.realtimeTranscription.liveStop}
  wsUrl={wsUrl}
  wsProtocols={wsProtocols}
  on:error={onError}
/>



